import { render } from "./Google.vue?vue&type=template&id=4bec69a2&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"

import "./Google.vue?vue&type=style&index=0&id=4bec69a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bec69a2"]])

export default __exports__